export { default as Img200 } from './processed/200/graff.jpg';
export { default as Img400 } from './processed/400/graff.jpg';
export { default as Imgthumb } from './processed/thumb/graff.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/graff.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/graff.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      92,
      124,
      248
    ],
    "_population": 2,
    "_hsl": [
      0.6324786324786325,
      0.9176470588235297,
      0.6666666666666666
    ]
  },
  "LightVibrant": {
    "_rgb": [
      114,
      137,
      248
    ],
    "_population": 69,
    "_hsl": [
      0.6380597014925373,
      0.9054054054054054,
      0.7098039215686275
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      44,
      51,
      95
    ],
    "_population": 31,
    "_hsl": [
      0.6437908496732027,
      0.3669064748201439,
      0.27254901960784317
    ]
  },
  "Muted": {
    "_rgb": [
      175,
      130,
      109
    ],
    "_population": 594,
    "_hsl": [
      0.05303030303030302,
      0.29203539823008856,
      0.5568627450980392
    ]
  },
  "LightMuted": {
    "_rgb": [
      198,
      176,
      168
    ],
    "_population": 211,
    "_hsl": [
      0.04444444444444443,
      0.20833333333333334,
      0.7176470588235294
    ]
  },
  "DarkMuted": {
    "_rgb": [
      52,
      52,
      99
    ],
    "_population": 57,
    "_hsl": [
      0.6666666666666666,
      0.3112582781456954,
      0.296078431372549
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/graff.js